import { render, staticRenderFns } from "./PartnershipMaster.vue?vue&type=template&id=0dc3ea1c&scoped=true"
import script from "./PartnershipMaster.vue?vue&type=script&lang=js"
export * from "./PartnershipMaster.vue?vue&type=script&lang=js"
import style0 from "./PartnershipMaster.vue?vue&type=style&index=0&id=0dc3ea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3ea1c",
  null
  
)

export default component.exports